import { render, staticRenderFns } from "./MailManagement.vue?vue&type=template&id=1386ad94&"
import script from "./MailManagement.vue?vue&type=script&lang=js&"
export * from "./MailManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports